import { Component, EventEmitter, Output, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'cw-radio-button',
    styleUrls: ['./radio-button.component.scss'],
    templateUrl: './radio-button.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CwRadioButtonComponent {
    @Input()
    public value: any = true;

    @Input()
    public name!: string;

    @Input()
    public model: any;

    @Output()
    public modelChange: EventEmitter<any> = new EventEmitter<any>();

    get checked(): boolean {
        return this.model === this.value;
    }

    public onRadioClick(): void {
        this.modelChange.emit(this.value);
    }
}
